export enum OdometerHourmeterReportMessages {
  title = "reports.odometerHourmeter.title",
  startDateTime = "reports.odometerHourmeter.startDateTime",
  endDateTime = "reports.odometerHourmeter.endDateTime",
  date = "reports.odometerHourmeter.date",
  vehicleCode = "reports.odometerHourmeter.vehicleCode",
  vehicleDescription = "reports.odometerHourmeter.vehicleDescription",
  originalAllocation = "reports.odometerHourmeter.originalAllocation",
  currentAllocation = "reports.odometerHourmeter.currentAllocation",
  totalOdometer = "reports.odometerHourmeter.totalOdometer",
  totalHourmeter = "reports.odometerHourmeter.totalHourmeter",
  dailyOdometer = "reports.odometerHourmeter.dailyOdometer",
  dailyHourmeter = "reports.odometerHourmeter.dailyHourmeter",
  noDataFound = "reports.odometerHourmeter.noDataFound",
  invalidFilter = "reports.odometerHourmeter.invalidFilter",
  success = "reports.odometerHourmeter.success",
  error = "reports.odometerHourmeter.error",
  invalidDateRange = "reports.odometerHourmeter.invalidDateRange",
  fleet = "reports.odometerHourmeter.fleet",
  selectVehicle = "reports.odometerHourmeter.selectVehicle",
  allVehicles = "reports.odometerHourmeter.allVehicles"
}

export type TranslationOdometerHourmeterReportMessages = {
  [OdometerHourmeterReportMessages.title]: string,
  [OdometerHourmeterReportMessages.startDateTime]: string,
  [OdometerHourmeterReportMessages.endDateTime]: string,
  [OdometerHourmeterReportMessages.date]: string,
  [OdometerHourmeterReportMessages.vehicleCode]: string,
  [OdometerHourmeterReportMessages.vehicleDescription]: string,
  [OdometerHourmeterReportMessages.originalAllocation]: string,
  [OdometerHourmeterReportMessages.currentAllocation]: string,
  [OdometerHourmeterReportMessages.totalOdometer]: string,
  [OdometerHourmeterReportMessages.totalHourmeter]: string,
  [OdometerHourmeterReportMessages.dailyOdometer]: string,
  [OdometerHourmeterReportMessages.dailyHourmeter]: string,
  [OdometerHourmeterReportMessages.noDataFound]: string,
  [OdometerHourmeterReportMessages.invalidFilter]: string,
  [OdometerHourmeterReportMessages.success]: string,
  [OdometerHourmeterReportMessages.error]: string,
  [OdometerHourmeterReportMessages.invalidDateRange]: string,
  [OdometerHourmeterReportMessages.fleet]: string,
  [OdometerHourmeterReportMessages.selectVehicle]: string,
  [OdometerHourmeterReportMessages.allVehicles]: string,
};
